import React, { useRef } from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import { useNav } from '../../hx/useNav';
import CxHidden from '../../cx/CxHidden';
import CxInput from '../../cx/CxInput';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import { StoreSettPsGroup } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';


const MxSettPsGroupForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();

  let r_form = React.useRef(null);

  const [storeSettPsGroup, setStoreSettPsGroup] = useSessionStorage('StoreSettPsGroup', StoreSettPsGroup);

  const formLoad = async (data) => {
    if (data===null) { //nuevo registro
    }
  }
  const formSave = async (lastSaveRv) => {
    if (lastSaveRv.theStatus==='error') {
    } else {
      storeSettPsGroup.itPsGroup = lastSaveRv.theValue;
      Promise.all([setStoreSettPsGroup(storeSettPsGroup)]).then((result) => {
        navBack();
      });
    }
  }
  const formDelete = async (rv) => {
  }

  return (
    <div>
      <GxForm 
        moduleName={`${trans('field.pss')}: ${trans('field.group')}`}
        xref={r_form}
        url="sett/ps_group" 
        tooltip={trans('field.group')}
        filterIdField='itPsGroup'
        filterIdValue={storeSettPsGroup.itPsGroup} 
        onFormLoad={formLoad} 
        onFormSave={formSave} 
        saveAndExit
        onFormDelete={formDelete} 
        >
        <CxHidden xref={useRef(null)} dbfield="t_ps_group.itPsGroup" value={storeSettPsGroup.itPsGroup || ''} />
        <CxInput xref={useRef(null)} label={trans('field.group')} dbfield="t_ps_group.txTypePsGroup" required />
        <CxInput xref={useRef(null)} label={trans('field.name_short')} dbfield="t_ps_group.txTypePsGroupShort" required />
        
      </GxForm>

    </div>
  );

}

export default MxSettPsGroupForm;
